






























































































import { defineComponent } from '@nuxtjs/composition-api'
import { useCountry } from '~/composables/country/useCountry'
export default defineComponent({
  setup() {
    const { isJapan, isCN } = useCountry()
    return { isJapan, isCN }
  },
})
